import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { checkErrors } from "../../../jsx/global-functions/checkErrors";
export const getUsersFunc = createAsyncThunk(
  "get users function",
  async (api, thunkAPI) => {
    const token = window.localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Include the token in the Authorization header
      },
    };
    try {
      const response = await axios.get(api, config);
      return response.data.data.users;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const getUsersSlicer = createSlice({
  name: "get users slicer",
  initialState: {
    loading: null,
    data: null,
    error: null,
  },
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getUsersFunc.pending, (state) => {
      state.loading = true;
      state.data = null;
      state.error = null;
    });
    builder.addCase(getUsersFunc.rejected, (state) => {
      state.loading = null;
      state.data = null;
      state.error = true;
    });
    builder.addCase(getUsersFunc.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    });
  },
});

export default getUsersSlicer.reducer;
